<div class="slider-track-wrapper" #sliderOuter>
  <div class="slider-track" [style.--fill-value]="valueInPercent">
    <div class="slider-track-inner">
      <div class="slider-thumb" [ngStyle]="{'left': valueInPercent + '%'}"></div>
    </div>
  </div>
</div>